import set from 'lodash/set';

export const providentQuotePreInputMergeHandler = (
  quoteData: Record<string, unknown>,
) => {
  if (
    'versicherungsendalter' in quoteData &&
    quoteData.beitragsendalter !== quoteData.versicherungsendalter
  ) {
    set(quoteData, 'temporaryInputFields.abweichendeBeitragszahlung', true);
  }

  if (
    'leistungsendalter' in quoteData &&
    quoteData.beitragsendalter !== quoteData.leistungsendalter
  ) {
    set(quoteData, 'temporaryInputFields.abweichendesLeistungsendalter', true);
  }

  return quoteData;
};
